import { Machine } from "models/Machine";
import { MachineDefect } from "models/MachineDefect";
import { MachineMaintenance } from "models/MachineMaintenance";
import { UserShortRef } from "models/User";

export class UserTask {
    id: number;
    machine: Machine;
    dateCreated: Date;
    userCreated?: UserShortRef;
    dateTodo: Date;
    userToDo?: UserShortRef;
    dateFinished: Date; // not nullable in the backend, 0001-01-01 while open
    userFinished?: UserShortRef;
    machineDefect?: MachineDefect;
    machineMaintenance?: MachineMaintenance;
    archivedDate?: Date;

    constructor(
        id: number,
        machine: Machine,
        dateCreated: Date,
        dateTodo: Date,
        dateFinished: Date,
        userCreated?: UserShortRef,
        userToDo?: UserShortRef,
        userFinished?: UserShortRef,
        machineDefect?: MachineDefect,
        machineMaintenance?: MachineMaintenance,
        archivedDate?: Date
    ) {
        this.id = id;
        this.machine = machine;
        this.dateCreated = dateCreated;
        this.userCreated = userCreated;
        this.dateTodo = dateTodo;
        this.userToDo = userToDo;
        this.dateFinished = dateFinished;
        this.userFinished = userFinished;
        this.machineDefect = machineDefect;
        this.machineMaintenance = machineMaintenance;
        this.archivedDate = archivedDate;
    }

    static empty(): UserTask {
        return {
            id: 0,
            machine: Machine.empty(),
            dateCreated: new Date(),
            dateTodo: new Date(),
            dateFinished: new Date('0001-01-01'),
        };
    }

    static isOpen(t: UserTask): boolean {
        return new Date(t.dateFinished).getFullYear() <= 1;
    }

    static description(t: UserTask): string {
        return t.machineDefect?.defect ?? t.machineMaintenance?.maintenance.name ?? '';
    }
}
